import { render, staticRenderFns } from "./AddPersonalNotification.vue?vue&type=template&id=8449466c&scoped=true&"
import script from "./AddPersonalNotification.vue?vue&type=script&lang=js&"
export * from "./AddPersonalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8449466c",
  null
  
)

export default component.exports